import { useCallback, useEffect, useState } from "react";
import {

  DesignTokens,
  Row,
  Col,
  Button,
  UndoIcon,

} from "melco-ui";

//import moment from "moment";
import { useTranslation } from "react-i18next";
import { isEmpty, some } from "lodash-es";

import { LocaleStringsListFiltersType } from "../../hooks/localestrings/LocaleStringsListFilterType";
import { LocaleStringsDownloadButton } from "./LocaleStringDownloadButton";
import { LocaleStringsUploadButton } from "./LocalStringUploadButton";
import { Search } from "../search/Search";
import { CultureCodeFilter } from "./filter/CultureCodeFilter";
import { PRODUCT_CODE } from "../../helper/localestringHelper";
import styled from "styled-components";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
const { spacings } = DesignTokens;



type LocaleStringsListFilterProps = {
  onFiltersChange: (filters: LocaleStringsListFiltersType | undefined) => void;
  refetch: () => void;
  setLocaleStringsListFiltersValues: (v: LocaleStringsListFiltersType | undefined) => void;
};

export const LocaleStringsListFilter: React.FC<LocaleStringsListFilterProps> = ({
  onFiltersChange,
  refetch,
  setLocaleStringsListFiltersValues
}) => {
  const { t } = useTranslation();

  const [localeStringsFilter, setLocaleStringsFilter] = useState<
    LocaleStringsListFiltersType | undefined
  >();

  const { roles } = useRolesContext();

  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    console.log({ localeStringsFilter })
    onFiltersChange(localeStringsFilter);
    setLocaleStringsListFiltersValues(localeStringsFilter);
  }, [localeStringsFilter, onFiltersChange]);

  // this code make be needed for Reset Button
  const resetFilter = useCallback(() => {
    setSearchValue("");
    setLocaleStringsFilter(undefined);
    setLocaleStringsListFiltersValues(undefined);
  }, []);

  const BoxWrapper = styled.div`
  margin-left: 15px
`;


  return (<div>
    <Row gutter={[spacings.middle, spacings.middle]}>
      <Col flex={0}>
        <Search
          onSearchInputChange={(value) => {
            setLocaleStringsFilter((prevFilter) => {
              return { ...prevFilter, searchText: value };
            });
          }}
          onChange={(e) => setSearchValue(e.target.value)}
          value={searchValue}
        />
      </Col>
      <Col flex={1}>
        <CultureCodeFilter
          onChange={(value) => {
            setLocaleStringsFilter((prevFilter) => {
              return {
                ...prevFilter,
                cultureCode: !isEmpty(value) ? value : undefined,
              };
            });
          }}
          value={localeStringsFilter?.cultureCode ?? undefined}

        />
      </Col>




      <Col xs={6} md={5} xl={3}>
        {some(localeStringsFilter) && (
          <Button
            icon={<UndoIcon />}
            type="primary"
            onClick={resetFilter}
            data-cy-id="localestrings-filter-reset"
            style={{ minWidth: "100%" }}
          >
            {t("filter.reset.button", { ns: "melco-common" })}
          </Button>
        )}
      </Col>

      {
        roles.SYSTEM_STRINGS_UPLOAD &&
        <Col xs={6} md={5} xl={3}>
          <LocaleStringsUploadButton
            productCode={PRODUCT_CODE}
            cultureCode={localeStringsFilter?.cultureCode}
            refetch={refetch}
          />
        </Col>}

      {roles.SYSTEM_STRINGS_DOWNLOAD &&
        <Col xs={6} md={5} xl={3}>
          <BoxWrapper>
            <LocaleStringsDownloadButton
              productCode={PRODUCT_CODE}
              cultureCode={localeStringsFilter?.cultureCode}
            />
          </BoxWrapper>
        </Col>
      }
    </Row>
  </div>
  );

};
